export const BLACK = '#232323';
export const WHITE = '#fafafa';
export const GREY = '#4e4f50';
